import React from "react";
import {
  HeadingLarge,
  HeadingMedium,
  HeadingSmall,
  ParagraphMomento,
} from "@tumomento/ui";
import "./Post.scss";
import { IArticle } from "@/interfaces/IArticle.interface";
import { parseDate } from "@/utils/functions";
import { useDimensions } from "@/hooks/useDimensions";

export const Post = ({
  title,
  subtitle = "",
  image = "",
  publishDate = "",
  author = "",
  linkedinUrl,
  readingTime = "",
}: IArticle) => {
  const { isMobile } = useDimensions();
  return (
    <div className="post flex justify-flex-start align-strech">
      <figure className="post__image mb-4">
        <img src={image} alt={title} />
      </figure>
      <div className="flex col g-2 post__container">
        <HeadingLarge className={!isMobile ? "heading-xl" : ''}  color="basicWhite">
          {title}
        </HeadingLarge>
        {!isMobile &&
          <HeadingMedium color="green5" className="heading-l-light mb-3">
            {subtitle}
          </HeadingMedium>
        }
         <ParagraphMomento color='green5' typography="body-m" className="beatrice-0">
          Tiempo de lectura: {readingTime}
        </ParagraphMomento>
        <div className="flex col pt-7">
          <div className="flex row g-1">
            <ParagraphMomento
              color="green2"
              typography="heading-s"
            >
              Por:
            </ParagraphMomento>
            <a
              className="momento-text heading-s green2 underlined"
              href={linkedinUrl}
              target="_blank"
            >
              {author}
            </a>
          </div>
          <ParagraphMomento color="green2" typography="body-m" className="pb-3 ">
            {parseDate(publishDate)}
          </ParagraphMomento>
        </div>
      </div>
    </div>
  );
};
